export const teamData = [
  {
    id: "dr-sanad-pawar",
    name: "Dr. Sanad D. Pawar",
    designation: "Director, UMED Rehabilitation Centre",
    qualification: "MBBS, DPM, MIPS (Consultant Psychiatrist, Deaddiction Specialist, Sexologist)",
    image: "/dr-sanad-pawar.png",
    bio: "Director at UMED Rehabilitation Centre. Consultant Psychiatrist specializing in clinical psychiatry, de-addiction medicine, and sexual health.",
    departments: ["Clinical Psychiatry", "Deaddiction Medicine", "Medical Administration"]
  },
  {
    id: "mrs-varsha-pawar",
    name: "Mrs. Varsha Sanad Pawar",
    designation: "Administrator, UMED Rehabilitation Centre",
    qualification: "M.Sc (Microbiology), D.M.L.T",
    image: "/mrs-varsha-pawar.jpg",
    bio: "Administrator at UMED Rehabilitation Centre, leading operational management, clinical diagnostics, and facility administration.",
    departments: ["Healthcare Administration", "Facility Operations"]
  },
  {
    id: "dr-dg-pawar",
    name: "Dr. D.G. Pawar",
    designation: "Medical Officer, UMED Rehabilitation Centre",
    qualification: "MBBS, DPH (Retd. Government Officer)",
    image: "/dr-dg-pawar.png",
    bio: "Medical Officer at UMED Rehabilitation Centre. Retd. Government Officer with decades of clinical experience in public health and medical supervision.",
    departments: ["Medical Care", "Public Health"]
  }
];
